<template>
  <VSpinner v-if="isLoading" class="offset-top-2" />
  <article v-else>
    <VServiceDisplay :selected-service="serviceId" />

    <VNotification v-if="isSuccess" type="SUCCESS" heading="" class="offset-top-2" inner-class="offset-bottom-1" icon="icon-confirm icon-large" middle>
      <span class="notification-heading">
        <div class="inner">
          <div class="notification-content media-left">
            {{ $t('payment.successful_response', { grossAmount, netAmount }) }}
          </div>
        </div>
      </span>
    </VNotification>

    <VNotification v-else type="ERROR" heading="payment.book_error_headline" class="offset-top-2" inner-class="offset-bottom-1">
      <span class="offset-right-1">{{ errorContent }}</span>
    </VNotification>

    <div class="offset-top-2 pull-right">
      <VButton label="payment.progress_button_new_booking" class="btn-default offset-right-1" @click="onNewBooking" />
      <VButton
        v-if="xtcBookingResponse.xid"
        v-focus
        label="payment.view_transaction_button_label"
        class="btn-default btn-brand"
        @click="onPaymentTransaction"
      />
    </div>
  </article>
</template>

<script>
import VNotification from '@/components/Notification';
import VButton from '@/components/Button';
import VServiceDisplay from '@/components/PaymentGeneration/ServiceDisplay';
import VSpinner from '@/components/Spinner';
import { PAYMENT_GENERATION, PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS } from '@/router/route-types';
import TitleMixin from '@/mixins/title';
import formatCurrency from '@/mixins/formatCurrency';
import focus from '@/directives/focus';
import { mapState } from 'vuex';

export default {
  name: 'ProductConfirmation',

  components: {
    VButton,
    VServiceDisplay,
    VNotification,
    VSpinner,
  },

  directives: {
    focus,
  },

  mixins: [TitleMixin, formatCurrency],

  computed: {
    isLoading() {
      return this.xtcBookingResponse === null;
    },

    isSuccess() {
      return this.xtcBookingResponse?.callStatus === 'SUCCESS';
    },

    serviceId() {
      return this.xtcBookingResponse.serviceId;
    },

    grossAmount() {
      return this.formatCurrency(
        this.xtcBookingResponse.price.grossAmount,
        this.xtcBookingResponse.price.currency,
        -1 * Math.pow(10, this.xtcBookingResponse.price.decimalPlaces)
      );
    },

    netAmount() {
      return this.formatCurrency(
        this.xtcBookingResponse.price.netAmount,
        this.xtcBookingResponse.price.currency,
        -1 * Math.pow(10, this.xtcBookingResponse.price.decimalPlaces)
      );
    },

    errorContent() {
      const key = `payment.${this.xtcBookingResponse.errorText}`;
      if (this.$te(key)) {
        return this.$t(key);
      } else {
        throw this.xtcBookingResponse.error;
      }
    },

    ...mapState('payment', ['xtcBookingResponse']),
  },

  methods: {
    onNewBooking() {
      this.$router.push({
        name: PAYMENT_GENERATION,
      });
    },

    onPaymentTransaction() {
      const transactionId = '' + this.xtcBookingResponse.xid;
      const today = new Date().toISOString().slice(0, 10);
      this.$router.push({
        name: PAYMENT_TRANSACTIONS_OVERVIEW_DETAILS,
        params: { transactionId, from: today, to: today, tab: 'basic' },
      });
    },
  },
};
</script>
